export const PUBLIC_NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'Our Services', path: '/our-services' },
  { label: 'Client Dashboard', path: '/client-dashboard' },
  { label: 'Contact Us', path: '/contact-us' },
];

export const CLEAN_PUBLIC_ROUTES = [
  '/',
  '/streaming-ads-set-up',
  '/our-services',
  '/client-dashboard',
  '/contact-us',
  '/privacy-policy',
  '/terms',
  '/search',
  '/page-suspended',
  '/server-landing-page',
  '/sitemap',
  '/our-services/design/web-design-in-tampa',
  '/our-services/seo/seo-experts-around-the-web',
  '/our-services/seo/local-seo',
  '/our-services/seo/seo-pricing',
  '/our-services/hosting/a2g-hosting-package',
  '/our-services/marketing/streaming-advertising',
  '/our-business-services',
  '/our-business-services/web-design-services-in-tampa',
  '/our-business-services/local-toll-free-services',
  '/our-business-services/full-color-printing-in-tampa',
  '/our-business-services/seo-experts-in-tampa',
  '/our-business-services/seo-pricing',
  '/our-business-services/hosting-reseller',
  '/our-business-services/accessibility',
  '/our-business-services/design-services-in-tampa',
  '/our-business-services/full-color-printing-in-tampa/business-cards',
  '/our-business-services/full-color-printing-in-tampa/postcards',
  '/our-business-services/full-color-printing-in-tampa/bookmarks',
];

export const LEGACY_ROUTE_REDIRECTS = [
  { from: '/streaming-ads-set-up.html', to: '/streaming-ads-set-up' },
  { from: '/our-services.html', to: '/our-services' },
  { from: '/client-dashboard.html', to: '/client-dashboard' },
  { from: '/contact-us.html', to: '/contact-us' },
  { from: '/privacy-policy.html', to: '/privacy-policy' },
  { from: '/terms.html', to: '/terms' },
  { from: '/search.html', to: '/search' },
  { from: '/page-suspended.html', to: '/page-suspended' },
  { from: '/server-landing-page.html', to: '/server-landing-page' },
  { from: '/sitemap.html', to: '/sitemap' },
  { from: '/our-services/design/web-design-in-tampa.html', to: '/our-services/design/web-design-in-tampa' },
  { from: '/our-services/seo/seo-experts-around-the-web.html', to: '/our-services/seo/seo-experts-around-the-web' },
  { from: '/our-services/seo/local-seo.html', to: '/our-services/seo/local-seo' },
  { from: '/our-services/seo/seo-pricing.html', to: '/our-services/seo/seo-pricing' },
  { from: '/our-services/hosting/a2g-hosting-package.html', to: '/our-services/hosting/a2g-hosting-package' },
  { from: '/our-services/marketing/streaming-advertising.html', to: '/our-services/marketing/streaming-advertising' },
  { from: '/our-business-services.html', to: '/our-business-services' },
  { from: '/our-business-services/web-design-services-in-tampa.html', to: '/our-business-services/web-design-services-in-tampa' },
  { from: '/our-business-services/local-toll-free-services.html', to: '/our-business-services/local-toll-free-services' },
  { from: '/our-business-services/full-color-printing-in-tampa.html', to: '/our-business-services/full-color-printing-in-tampa' },
  { from: '/our-business-services/seo-experts-in-tampa.html', to: '/our-business-services/seo-experts-in-tampa' },
  { from: '/our-business-services/seo-pricing.html', to: '/our-business-services/seo-pricing' },
  { from: '/our-business-services/hosting-reseller.html', to: '/our-business-services/hosting-reseller' },
  { from: '/our-business-services/accessibility.html', to: '/our-business-services/accessibility' },
  { from: '/our-business-services/design-services-in-tampa.html', to: '/our-business-services/design-services-in-tampa' },
  { from: '/our-business-services/full-color-printing-in-tampa/business-cards.html', to: '/our-business-services/full-color-printing-in-tampa/business-cards' },
  { from: '/our-business-services/full-color-printing-in-tampa/postcards.html', to: '/our-business-services/full-color-printing-in-tampa/postcards' },
  { from: '/our-business-services/full-color-printing-in-tampa/bookmarks.html', to: '/our-business-services/full-color-printing-in-tampa/bookmarks' },
];

export const CONTENT_ROUTE_META = {
  '/our-services': {
    title: 'Our Services',
    description: 'Explore A2G Designs web design, hosting, SEO, VOIP, print design, printing, SEO suites, and reseller services.',
  },
  '/contact-us': {
    title: 'Contact Us',
    description: 'Contact A2G Designs for branding, web design, development, online marketing, print design, photography, and video production.',
  },
  '/client-dashboard': {
    title: 'Client Dashboard',
    description: 'Quick access to A2G client resources including domains, support, billing, analytics, email, and communication tools.',
  },
  '/terms': {
    title: 'Terms & Conditions',
    description: 'Review the terms and conditions for web design, development and hosting services from A2G Designs Web Solutions.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy',
    description: 'Review the live privacy policy information published by A2G Designs Web Solutions.',
  },
};